export const QA_NAME_EMAIL_PROFILE_UNAVAILABLE_NAVIGATION_PREVIOUS =
  'emailProfileUnavailablePrevious'

export const QA_NAME_EMAIL_PROFILE_UNAVAILABLE_NAVIGATION_NEXT =
  'emailProfileUnavailableNext'
